<template>
  <v-form ref="form" flat class="px-6">
    <div class="text-subtitle-1 font-weight-medium mt-3 mb-3">Thông tin khóa học</div>
    <autocomplete-major
      item-value="id"
      item-text="title"
      label="Chuyên Ngành"
      v-model="major"
      :defaultMajors="[]"
      return-object
      required
      dense
      outlined
      :rules="[$rules.required]"
      @change="onMajorChanged"
    ></autocomplete-major>
    <v-autocomplete
      @change="onCourseChanged"
      v-model="course"
      item-text="title"
      :items="getCourseItems"
      return-object
      item-value="id"
      label="Môn học"
      required
      dense
      outlined
      :rules="[$rules.required]"
    ></v-autocomplete>
    <v-text-field
      :rules="[$rules.required]"
      ref="code"
      v-model="code"
      label="Mã lớp"
      hint="Không sử dụng dấu cách và dấu phẩy"
      required
      persistent-hint
      dense
      outlined
    ></v-text-field>
    <!-- :rules="[$rules.required]" -->
    <autocomplete-generation
      v-model="generation"
      item-text="name"
      item-value="id"
      label="Khóa"
      required
      outlined
      dense
    ></autocomplete-generation>
    <v-text-field
      :rules="[$rules.required]"
      v-model="tags"
      label="Tên Nhóm"
      dense
      outlined
    ></v-text-field>
    <date-picker
      :rules="[$rules.required]"
      :date.sync="startTime"
      label=" Ngày bắt đầu"
      dense
    ></date-picker>
    <div class="text-subtitle-1 font-weight-medium mb-3">Thông tin lớp học</div>
    <v-select
      v-model="courseMarkConfig"
      item-text="title"
      item-value="id"
      :items="courseMarkConfigItems"
      label="Cấu hình điểm"
      placeholder="Chọn cấu hình điểm"
      height="42"
      dense
      outlined
    ></v-select>
    <autocomplete-teacher
      :rules="[$rules.required]"
      v-model="teachers"
      :defaultTeachers="teachers"
      item-text="name"
      item-value="id"
      deletable-chips
      chips
      small-chips
      label="Giáo viên"
      multiple
      dense
      outlined
    ></autocomplete-teacher>
    <autocomplete-teacher
      v-model="mentors"
      item-text="name"
      chips
      small-chips
      deletable-chips
      item-value="id"
      label="Trợ Giảng"
      dense
      multiple
      outlined
    ></autocomplete-teacher>
    <!-- <autocomplete-teacher
      v-model="grading_teachers"
      item-text="name"
      chips
      small-chips
      deletable-chips
      item-value="id"
      label="Giáo viên chấm cuối môn"
      dense
      multiple
      outlined
    ></autocomplete-teacher> -->
    <autocomplete-room
      v-model="room"
      item-text="title"
      item-value="id"
      label="Phòng học"
      dense
      outlined
      :rules="[$rules.required]"
    />
    <v-text-field
      :rules="[$rules.url]"
      v-model="facebook_group"
      label="Nhóm Facebook"
      placeholder="Nhập đường dẫn nhóm Facebook"
      outlined
      dense
    ></v-text-field>
    <v-text-field
      :rules="[$rules.url]"
      v-model="drive_link"
      label="Nhóm"
      placeholder="Nhập đường dẫn ổ Drive"
      outlined
      dense
    ></v-text-field>
  </v-form>
</template>
<script>
import { get } from 'lodash'
import AutocompleteGeneration from '@/components/basic/input/AutocompleteGeneration'
import DatePicker from '@/components/basic/picker/DateIOSPicker.vue'
import AutocompleteTeacher from '@/components/basic/input/AutocompleteTeacher'
import AutocompleteMajor from '@/components/basic/input/AutocompleteMajor'
import AutocompleteRoom from '@/components/basic/input/AutocompleteRoom'
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  components: {
    DatePicker,
    AutocompleteTeacher,
    AutocompleteRoom,
    AutocompleteMajor,
    AutocompleteGeneration
  },
  props: {
    classData: {
      type: [Object],
      required: true,
      default: () => {}
    },
    majorData: Object,
    courseData: Object
  },
  data: () => ({
    facebook_group: '',
    drive_link: '',
    valid: true,
    course: '',
    major: '',
    startTime: new Date().toISOString(),
    tags: '',
    endTime: '',
    code: '',
    generation: '',
    teachers: [],
    mentors: [],
    // grading_teachers: [],
    staff: {},
    room: '',
    courseMarkConfig: ''
  }),
  computed: {
    ...mapState('course', ['courseMarkConfigs']),
    courseMarkConfigItems() {
      if (!this.course) {
        return []
      }
      return this.courseMarkConfigs.filter(i => i.course.id === this.course.id)
    },
    getCourseItems() {
      return this.major ? this.major.courses : []
    }
  },

  methods: {
    ...mapActions('course', ['fetchCourseMarkConfigs']),
    onMajorChanged() {
      this.course = null
      this.courseMarkConfig = null
    },
    onCourseChanged() {
      this.courseMarkConfig = null
    },
    getCourseFilter() {
      return { major: get(this.major, 'id', null) }
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    getData() {
      if (this.$refs.form.validate()) {
        return {
          teachers: this.teachers,
          code: this.code,
          title: this.course.title,
          room: this.room,
          tags: this.tags,
          course: this.course.id,
          major: this.major.id,
          generation: this.generation,
          startTime: this.startTime,
          status: 'opended',
          endTime: this.endTime,
          mentors: this.mentors,
          drive_link: this.drive_link,
          facebook_group: this.facebook_group,
          // grading_teachers: this.grading_teachers,
          course_mark_config: this.courseMarkConfig,
          metadata: {
            mark: this.course.mark,
            ...this.course.data
          }
        }
      }
    },
    cancel() {
      this.resetDefault()
      this.$emit('cancel')
    },
    resetDefault() {
      if (this.classData) {
        this.teachers = this.classData.teachers
        this.mentors = this.classData.mentors
        this.tags = this.classData.tags
        this.room = this.room
        this.code = this.classData.code
        this.course = this.courseData || this.classData.course
        this.major = this.majorData || this.classData.major
        this.startTime = this.classData.startTime
        this.generation = this.classData.generation
        this.endTime = this.classData.endTime
        this.staff = get(this.classData, 'staff.id', null)
        // this.courseMarkConfig = this.classData.course_mark_config.id
        this.drive_link = this.classData.drive_link
        this.facebook_group = this.classData.facebook_group
      } else {
        this.teachers = []
        this.mentors = []
        this.room = ''
        this.code = ''
        this.course = null
        this.major = null
        this.tags = ''
        this.startTime = ''
        this.generation = ''
        this.endTime = ''
        this.staff = ''
        this.courseMarkConfig = ''
      }
    }
  },
  created() {
    this.resetDefault()
  },
  watch: {
    classData() {
      this.resetDefault()
    },
    course(v) {
      if (v && v.id) {
        this.fetchCourseMarkConfigs(v.id)
      }
    }
  }
}
</script>

<style scoped></style>
